import React from 'react';
import { Divider, IconButton, TextField } from '@material-ui/core';
import { EeInput } from 'components/EeInput/EeInput';
import { EeSelect } from 'components/EeSelect/EeSelect';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import CancelOutlinedIcon from '@material-ui/icons/CancelOutlined';
import { Controller, useFormContext } from 'react-hook-form';
import { KPI } from 'types/kpi';
// @ts-ignore
import { Autocomplete } from '@material-ui/lab';

interface KPIEditorProps {
  kpi: KPI;
  groupOptions: string[];
  typeOptions: any[];
  index: number;
  onChange: (kpi: any) => void;
  onDelete?: (kpi: any) => void;
  isEditMode: boolean;
}

export const KPIEditor: React.FC<KPIEditorProps> = ({
  kpi,
  groupOptions,
  typeOptions,
  index,
  isEditMode,
  onDelete,
}) => {
  const { control, errors } = useFormContext();

  return (
    <div className="editor-kpi-form position-relative">
      {index > 0 && (
        <IconButton
          className="position-absolute lens-scenarios-exit"
          style={{ right: 0, top: 8 }}
          onClick={() => onDelete && onDelete(index)}
        >
          <CancelOutlinedIcon />
        </IconButton>
      )}
      <Divider style={{ backgroundColor: '#2f3b4c' }} />
      <div className="d-flex align-items-center mb-3 lens-align-start">
        <div className="flex-grow-1 mr-3">
          <label className="text-uppercase fs-12 mb-1 lens-ee-label">
            KPI Name<sup>*</sup>
          </label>
          <Controller
            name={`kpiEditor[${index}].name`}
            control={control}
            defaultValue={kpi?.name}
            error={!!errors.kpiEditor?.[index]?.name}
            errorText={errors.kpiEditor?.[index]?.name?.message}
            as={(props) => (
              <EeInput {...props} inputProps={{ maxLength: 50 }} />
            )}
          />
        </div>
        <div>
          <label className="text-uppercase fs-12 mb-1 lens-ee-label">
            KPI Type<sup>*</sup>
          </label>
          <Controller
            disabled={isEditMode}
            name={`kpiEditor[${index}].type`}
            control={control}
            error={!!errors.kpiEditor?.[index]?.type}
            errorText={errors.kpiEditor?.[index]?.type?.message}
            items={typeOptions}
            defaultValue={kpi?.type || typeOptions[0].name}
            as={(props) => {
              props.onBlur();
              return <EeSelect {...props} />
            }}
          />
        </div>
      </div>
      <div className="mb-3">
        <label className="text-uppercase fs-12 mb-1 lens-ee-label">
          KPI Group<sup>*</sup>
        </label>
        <Controller
          render={({ onChange, ...props }) => (
            <Autocomplete
              freeSolo
              autoSelect
              options={groupOptions}
              popupIcon={<ExpandMoreIcon />}
              renderInput={(params: any) => (
                <TextField
                  {...params}
                  error={!!errors.kpiEditor?.[index]?.group}
                  helperText={errors.kpiEditor?.[index]?.group?.message}
                  InputProps={{
                      classes: {
                        root: "lens-text-field-root",
                      }
                  }}
                />
              )}
              onChange={(e: any, data: any) => onChange(data)}
              className="lens-autocomplete"
              {...props}
            />
          )}
          onChange={([, data]: any) => data}
          defaultValue={kpi?.group}
          name={`kpiEditor[${index}].group`}
          control={control}
        />
      </div>
      <div className="mb-1">
        <label className="text-uppercase fs-12 mb-1 lens-ee-label">KPI Description</label>
        <Controller
          name={`kpiEditor[${index}].description`}
          control={control}
          defaultValue={kpi?.description}
          error={!!errors.kpiEditor?.[index]?.description}
          errorText={errors.kpiEditor?.[index]?.description?.message}
          as={(props) => <EeInput {...props} inputProps={{ maxLength: 50 }} />}
        />
      </div>
    </div>
  );
};
